<template>
  <div>
    <div v-if="!type" v-loading.fullscreen.lock="allLoading"></div>
    <div v-if="type">
        <el-select v-model="num" placeholder="请选择">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
        </el-select>
        <el-table v-for="(item,index) in tableData"
                  :key="index"
                  :data="item.rows"
                  style="width: 100%;margin-top:20px"
                  v-show="item.name == num"
                  height="600"
                  border>
            <el-table-column prop="a"
                             label="a">
            </el-table-column>
            <el-table-column prop="b"
                             label="b">
            </el-table-column>
            <el-table-column prop="c"
                             label="c">
            </el-table-column>
            <el-table-column prop="d"
                             label="d">
            </el-table-column>
            <el-table-column prop="e"
                             label="e">
            </el-table-column>
            <el-table-column prop="f"
                             label="f">
            </el-table-column>
            <el-table-column prop="g"
                             label="g">
            </el-table-column>
            <el-table-column prop="h"
                             label="h">
            </el-table-column>
            <el-table-column prop="i"
                             label="i">
            </el-table-column>
            <el-table-column prop="j"
                             label="j">
            </el-table-column>
            <el-table-column prop="k"
                             label="k">
            </el-table-column>
            <el-table-column prop="l"
                             label="l">
            </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
    import { getDivList } from '@/api/index.js'
    export default {
        data() {
            return {
                tableData: [],
                tableList: [],
                type: false,
                options: [],
                num: 1,
                allLoading:true
            }
        },
        created() {
            this.init()
        },
        methods: {
            test(row) {
                console.log(row)
            },
            init() {
                getDivList({
                    id: this.$route.query.divid
                }).then(res => {
                    if (res.status == 0) {
                        res.tables.forEach((ele) => {
                            if (ele.year == '2019') {
                                this.tableData.push(ele)
                            }
                        })
                        if(this.tableData.length == 0){
                          this.$message.success('去年无数据')
                        }
                        console.log(this.tableData)
                        for (let i = 1; i <= this.tableData.length; i++) {
                            let a = {
                                value: i,
                                label: `表${i}`
                            }
                            this.options.push(a)
                        }
                        this.type = true
                    }
                })
            },
        },
    }
</script>

<style scoped>
</style>